/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindOneQueryResponse, OrganizationsControllerFindOnePathParams, OrganizationsControllerFindOneQueryParams, OrganizationsControllerFindOne400, OrganizationsControllerFindOne401, OrganizationsControllerFindOne403, OrganizationsControllerFindOne404 } from "../../models/organizationsController/OrganizationsControllerFindOne";

function getOrganizationsControllerFindOneUrl(id: OrganizationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/organizations/${id}` as const }  
  return res
}

/**
 * @summary Get organization by id
 * {@link /api/v1/organizations/:id}
 */
export async function organizationsControllerFindOne(id: OrganizationsControllerFindOnePathParams["id"], params?: OrganizationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerFindOneQueryResponse, ResponseErrorConfig<OrganizationsControllerFindOne400 | OrganizationsControllerFindOne401 | OrganizationsControllerFindOne403 | OrganizationsControllerFindOne404>, unknown>({ method : "GET", url : getOrganizationsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}